export default __webpack_public_path__ + "static/media/leftAllow.c2f582cd.svg";